import React from 'react';
import './AdvancedDetails.css';

/**
 * The two "closed until wanted" disclosures of the apartment edit page (Issue #132, Variant 4).
 *
 * <p>Both are native `<details>`, not state in React, on purpose: the page's jump logic
 * (`apartmentEdit/jumpTo.ts`) opens every closed `<details>` above a field it has to reveal, so the
 * checklist, the search and old `?tab=` links keep landing on a field that sits inside one of them.
 * Anything rebuilt as a controlled component would have to be taught to that logic separately.
 */

interface AdvancedDetailsProps {
  title: string;
  /** How many fields are inside, shown as a small tag so a closed block does not look empty. */
  count?: number;
  id?: string;
  children: React.ReactNode;
}

/** Settings most managers never touch. Closed by default; the dashed border marks it as optional. */
export const AdvancedDetails: React.FC<AdvancedDetailsProps> = ({ title, count, id, children }) => (
  <details className="ae-adv" id={id}>
    <summary>
      {title}
      {count ? <span className="ae-tag">{count}</span> : null}
    </summary>
    <div className="ae-adv-in">{children}</div>
  </details>
);

interface HelpDetailsProps {
  title: string;
  children: React.ReactNode;
}

/** Explanatory text ("how does this work"), as opposed to settings. Closed by default. */
export const HelpDetails: React.FC<HelpDetailsProps> = ({ title, children }) => (
  <details className="ae-help">
    <summary>{title}</summary>
    <div className="ae-help-in">{children}</div>
  </details>
);
